import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconBookmarkFilled = createSVG({
    children: (jsx("path", { d: "M3.009 6.051q0-1.686 1.17-2.857Q5.35 2.001 7.014 2h9.974q1.663 0 2.833 1.195 1.17 1.169 1.17 2.855v14.915q0 .656-.584.936-.586.258-1.077-.164l-5.994-5.409A1.96 1.96 0 0 0 12 15.814q-.75 0-1.335.515L4.67 21.738q-.491.422-1.077.164-.585-.28-.585-.936z" })),
});

export { IconBookmarkFilled };
